<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { onMounted, computed } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import { useAuthStore } from "@core/stores/auth.store"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Validez votre compte",
            subtitle:
                "Entrez le code de validation reçu par e-mail pour valider votre compte.",
            alreadyValidated: "Vous avez déjà un compte ?",
            login: "Connectez-vous.",
        },
    },
})

// ================================
// COMPOSABLES
// ================================
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

// ================================
// COMPUTED
// ================================
const getFooterLinks = computed(() => [
    { text: t("alreadyValidated"), label: t("login"), link_to: "/login" },
])

// ================================
// LIFECYCLE
// ================================
onMounted(() => {
    if (route.params._id_user === "undefined" || !route.params._id_user) {
        router.push("/login")
    }
})

// ================================
// INTERACTIONS
// ================================
/** Après validation réussie : redirection accueil. */
function onValidationSuccess(): void {
    setTimeout(() => router.replace("/"), 2000)
}

/** Déconnecte l'utilisateur et masque l'erreur. */
function onSignOut(): void {
    authStore.logout()
}
</script>

<template>
    <BaseCard>
        <template #title>
            <FormAuthHeader :title="t('title')" :subtitle="t('subtitle')" />
        </template>
        <template #content>
            <FormAuthValidationForm
                class="py-6"
                @validation-success="onValidationSuccess"
                @sign-out="onSignOut"
            >
            </FormAuthValidationForm>
            <FooterLogin :links="getFooterLinks" :forget-password="true" />
        </template>
    </BaseCard>
</template>
